<template>
        <div class="customKanBan"  >
             <!-- 自定义看板 -->

             <div class="left-demo" id="left-demo" ref="dragContent">
                <!--  -->
                <div class="demo-bg-img1  demo-bg" v-show="switchValue">
                       <img :src="dialogImageUrl" width="100%" height="100%" >
                </div>
                <div class="demo-bg-mask demo-bg" v-show="maskChecked">
                    <img src="../../assets/customKanBan/mask.png" alt="" width="100%" height="100%" >
                </div>
                <div class="demo-bg-img2 demo-bg" :style="nowBgImg" @click.self="leftDemoClick"></div>
                
               <div class="big-title" :style="fontSize" @mousedown="titleMove($event)">{{titleName}} 
               </div>  
               <!--小模块-->
                <div :class="['moveBox',{'you-active':item.type == 1},{'moveBox-active':moveBoxIndex == index}]" @mousedown="tagDraggable($event,index)"   
                v-for="(item,index) in moveBoxList" :key="index" :id="'moveBox'+(index+1)" 
                :style="item.info" @contextmenu.prevent="rightClick($event,index)" @click="moveBoxClick_fn(index)" >
                    <div :class="['top-title',{'shape-active':shapeValue == '箭形'}]" :style="topTitleObj" v-if="item.type == 0"> 
                        <div class="delta" v-show="shapeValue =='箭形'" :style="deltaObj"></div>
                         <div class="straight-line" v-show="shapeValue =='直线'" :style="lineObj"></div> 
                        <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                    </div>
                    <!-- <el-popconfirm v-show="delFlag==index" title="确定要删除此模板吗？" @onConfirm.stop="del_fn(`moveBox${index+1}`)">
                        <template #reference> 
                            <span style="color:red" @click.stop="del_fn(`moveBox${index+1}`)">删除</span>
                         </template>
                        </el-popconfirm> -->
                    <div class="top-title2" v-if="item.type == 1"> 
                        <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                    </div>
                    <div class="small-icon1" v-if="item.type == 1 && item.cheekImgIndex == 0">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img1">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img2">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian2.png`)" alt="" class="img3">
                    </div>
                      <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 2">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line4.png`)" alt="" class="img4" style="height:1px">
                    </div>
                     <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 3">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie1.png`)" alt="" class="img1">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie2.png`)" alt="" class="img2">
                      <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line3.png`)" alt="" class="img4">
                    </div>
                     <div class="small-icon5" v-if="item.type == 1 && item.cheekImgIndex == 5">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img1">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img2">
                    </div>
                    <div class="add-del" v-show="item.rightMenu"  @click.stop="addDel_fn">
                      <div class="eait">
                            <div :class="['eait-item',{'eait-active':eaitIndex == i}]" v-for="(t,i) in rightMenuList" :key="i">
                              <span>{{t.name}}</span>
                              <el-input v-model="item[t.key]" @focus="eaitIndex = i" @blur="blur_fn(item[t.key],index)" @keyup.enter.native="$event.target.blur"></el-input>
                            </div>
                      </div>
                      <div class="del-btn">
                           <div @click.stop="del_fn(`moveBox${index+1}`)"> <p>删除</p>  <span>delet</span></div>
                           <div @click.stop="copy_fn(index)"> <p>复制</p>  <span>ctrl+c</span></div>
                           <div> <p>粘贴</p>  <span>ctrl+v</span></div>
                      </div>
                    </div>
                    <div class="lineMoveDiv"   @mousedown="moveLineWidth($event,`moveBox${index+1}`)"></div>
                    <div class="lineMoveDiv2"  @mousedown="moveLineHeight($event,`moveBox${index+1}`)"></div>
                </div>
                <!-- 组件-选项卡 -->
                <!-- <div class="zutab">
                  <div class="tab-item ">年</div>
                  <div class="tab-item tab-item-active">月</div>
                  <div class="tab-item">日</div>
                </div> -->
                <!-- 全屏缩小 -->
                <div class="full-screen" v-if="fullScreenStyle.length != 0" :style="fullScreenStyle[0].info" 
                @mousedown="zujianTagDraggable($event,0,2)"
                @click="screenRenovate_fn(0,fullScreenStyle[0])"
                >
                   <span class="icon iconfont icon-full-screen" v-show="!screenFlag"></span>
                   <span class="icon iconfont icon-suoxiao" v-show="screenFlag"></span>
                   <div class="screen" ></div>
                </div>
                <!-- 刷新 -->
                <div class="renovate" v-if="renovateStyle.length != 0" :style="renovateStyle[0].info" 
                @mousedown="zujianTagDraggable($event,0,3)"
                @click="screenRenovate_fn(1,renovateStyle[0])"
                >
                    <i class="el-icon-refresh-right"></i>
                    <div class="screen" ></div>
                </div>

                <!-- 天气 -->
                <div :class="['weather',{'weather-active':weathIndex == index}]" v-for="(item,index) in weatherList" :key="index + 100" :style="item.info" 
                @mousedown="zujianTagDraggable($event,index,item.type)" 
                 :id="'weather'+(index+1)">
                    <div class="weather-item" v-show="item.weatherCheckList.indexOf('天气类型') != -1">
                       <img :src="weatherImg"> {{Weather.weather}}
                    </div>
                    <div class="weather-item" v-show="item.weatherCheckList.indexOf('温度') != -1">
                        {{Weather.temperature}} ℃
                    </div>
                     <div class="weather-item" v-show="item.weatherCheckList.indexOf('风力') != -1">
                        {{Weather.winddirection}}风{{Weather.windpower}}级
                    </div>
                     <div class="weather-item" v-show="item.weatherCheckList.indexOf('湿度') != -1">
                        湿度 {{Weather.humidity}}％
                    </div>
                    <div class="tuo" @click="weathIndex = index;moveBoxIndex = timerIndex = -1"></div>
                </div>

                <!-- 日期 -->
                  <div :class="['timer',{'weather-active':timerIndex == index}]"   v-for="(item,index) in timerList" :key="index + 150" :style="item.info"  
                  @mousedown="zujianTagDraggable($event,index,item.type)" :id="'timer'+(index+1)">
                     <div class="weather-item" v-show="item.timerCheckList.indexOf('日期') != -1">
                        {{nowTime}}
                    </div>
                     <div class="weather-item" v-show="item.timerCheckList.indexOf('时间') != -1">
                         {{nowMin}}
                    </div>
                     <div class="weather-item" v-show="item.timerCheckList.indexOf('星期') != -1">
                         {{nowWeek}}
                    </div>
                    <div class="tuo" @click="timerIndex = index;moveBoxIndex = weathIndex =  -1"></div>
                </div>

             </div>
             <div :class="['right-select',{'right-active':settingFlag}]">
                <div class="btns">
                  <img src="../../assets/customKanBan/setting.png" @click="settingFlag = false" v-show="settingFlag" alt="">
                  <img src="../../assets/customKanBan/close.png" @click="settingFlag = true" v-show="!settingFlag" alt="">
                </div>
                <div class="right-title">
                    <div class="t-left">看板编辑</div>
                    <i class="el-icon-close" @click="settingFlag = true"></i>
                </div>
                <div class="tab">
                    <span v-for="(item,index) in tabList" :key="index" :class="{'span-active':index == tabIndex}" @click="tabIndex=index">{{item}}</span>
                </div>
                <!-- 框架编辑 -->
                <div class="kuajia" v-show="tabIndex == 0">
                     <!-- 背景图片 -->
                        <div class="m-left zhuti">
                            <div class="m-left"><span></span> 选择主题</div>
                             <el-upload
                                    action=""
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    accept="image/*"
                                    list-type="picture-card"
                                    :on-change="zhutiImg_fn"
                                >
                                     <el-button size="small" type="primary" class="zhuti-img" plain>上传自定义主题</el-button>
                                </el-upload>
                           
                        </div>
                        <div class="bigbg">
                            <el-scrollbar style="height:95%;width: 100%;">
                                    <div :class="['bg-img',{'active':index == activeIndex}]" v-for="(item,index) in bgImgList" :key="index" @click="change_bg(index)">
                                        <img :src="item.url" alt="">
                                        主题{{index +1}}
                                        <!-- <div class="mask"></div> -->
                                    </div>
                            </el-scrollbar>
                        </div>
                        <div class="m-left"><span></span> 选择背景图片</div>
                        <div class="mask-img">
                            <div class="noesd">
                                <el-upload
                                    action=""
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    accept="image/*"
                                    list-type="picture-card"
                                    :on-change="handlePictureCardPreview"
                                >
                                    <i class="el-icon-plus"  v-show="!dialogVisible"></i>
                                     <img width="100%" height="100px" v-show="dialogVisible" :src="dialogImageUrl" alt="">
                                </el-upload>
                                </div>
                           <el-switch v-model="switchValue" active-text="启用" inactive-text="" @change="switch_fn" :disabled='!dialogVisible'></el-switch>
                           <el-checkbox v-model="maskChecked">使用遮罩</el-checkbox>
                        </div>
                        <div class="m-left" style="margin-bottom:20px"><span></span> 编辑标题</div>
                        <div class="style-name nowarp">
                            <span >名称：</span><el-input   v-model="titleName" placeholder="请输入标题名称"  > </el-input>
                        </div>
                            <div class="style-size nowarp">
                            <span >大小：</span>  
                                <el-select v-model="sizeValue" placeholder="请选择" @change="fontSize_fn">
                                            <el-option v-for="item in fontSizeList"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                                </el-select>
                        </div>
                            <div class="style-color nowarp">
                            <span >颜色：</span><el-color-picker v-model="titleColor" show-alpha @change="color_fn"></el-color-picker>
                        </div>
                </div>
                <!-- 模块标题编辑 -->
                 <moduleTitle v-show="tabIndex == 1" 
                 :nowModulTitleObj='nowModulTitleObj' 
                 @modelTitleName_fn="modelTitleName_fn" 
                 @coordinate_fn='coordinate_fn' 
                 @moduleTitle_fn='moduleTitle_fn' 
                 @shape_fn="shape_fn" 
                 @moduleTitleColor_fn="moduleTitleColor_fn" 
                 @nowIcon_fn="nowIcon_fn"
                 @nowCheek_fn='nowCheek_fn'
                 @iconFlag_fn="iconFlag_fn"
                 ></moduleTitle>
                 <!-- 看板组件 -->
                 <assembly ref="assembly" v-show="tabIndex == 2" @assembly_fn='assembly_fn' :weathObj='weathObj' 
                 @weathers_fn="weathers_fn"  
                 @timers_fn='timers_fn' 
                 :trimerObj='trimerObj'
                 @screens_fn='screens_fn'
                 ></assembly>

             
                <!-- <el-button type="primary" @click="addMoveBox_fn">添加</el-button>-->
                <!-- <button @click="generateImages">下载图片</button>  -->
                <div class="save-kanban" v-show="!settingFlag">
                       <el-button type="primary" size="small">保存看板</el-button>
                </div>

             </div>
             
        </div>
  
</template>

<script>
import html2canvas from 'html2canvas'
  import cropperImg from "../../components/module/city_picker/cropper_img"; // 裁剪图片
  import moduleTitle from "./moduleTitle"; // 
  import assembly from "./assembly"; // 组件配置
  import resourcesStore from '@/cache/resourcesStore.js'
export default {
     components: { 
        cropperImg,
        moduleTitle,
        assembly
      },
    data(){
        return {
          zujianFlag:false,//组件操作
          screenFlag:false,//全屏/缩小
          //天气
          Weather:{},
          weathObj:{},
          weatherList:[],
          weathIndex:-1,
          weatherImg:"",
          setIntervalTimer:null,
          //时间
          timerList:[],
          trimerObj:{},
          setTimer:null,
          timerIndex:-1,
          nowTime:"",
          nowWeek:"",
          nowMin:"",
          //右击菜单
          rightMenuList:[
            {
              'name':'X',
              'key':'left'
            },
            {
              'name':'Y',
              'key':'top'
            },
            {
              'name':'W',
              'key':'width'
            },
            {
              'name':'H',
              'key':'height'
            },
          ],
          eaitIndex:-1,
          nowInputVal:0,
          moveBoxIndex:-1,//当前选中模块的索引
          nowModulTitleObj:{},//当前选中的模块标题样式
          rightClickMenu:false,//右击出现菜单
            titleName:"大标题",
            settingFlag:false,//控制右侧小模块的弹出跟收起
            //小模块
            moveBoxList:[],
            //右边选项卡
            tabList:['框架配置','模块配置','组件配置'],
            tabIndex:0,
            offsetWidth:0,//宽度
            offsetHeight:0,//高度
            delFlag:-1, //控制删除是否显示
            bgImgList:[
                {
                    'url':require('@/assets/customKanBan/blue.jpg'),
                    'urlTran':require('@/assets/customKanBan/blueTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/green.png'),
                    'urlTran':require('@/assets/customKanBan/greenTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/yellow.jpg'),
                    'urlTran':require('@/assets/customKanBan/yellowTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/qing.png'),
                    'urlTran':require('@/assets/customKanBan/qingTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme5.png'),
                    'urlTran':require('@/assets/customKanBan/theme5Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme6.png'),
                    'urlTran':require('@/assets/customKanBan/theme6Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme7.png'),
                    'urlTran':require('@/assets/customKanBan/theme7Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme8.png'),
                    'urlTran':require('@/assets/customKanBan/theme8Tran.png'),
                },
            ],//背景数据
            //正在使用的背景
            nowBgImg:{},
            activeIndex:0,//高亮背景框
            bgImgPhoto:"",//背景图片
            maskChecked:false,//是否使用遮罩
            switchValue:false,//是否启动背景图片
            //标题字体大小
            sizeValue:24,
            fontSizeList:[],
            fontSize:{},
            //标题字体颜色
            titleColor:'#fff',
              dialogImageUrl: '',
            dialogVisible: false,
            coordinate:{},//新增小模块的坐标
            shapeValue:"矩形", //小模块标题形状
            moduleBgColor:true, //小模块标题是否渐变
            moduleTitleColor:"#407cdd",//小模块标题颜色
            modelTitleName:{},//小模块标题文字
            topTitleObj:{} ,//小模块标题样式
            lineObj:{},//直线样式
            deltaObj:{},//箭头三角形样式
            nowIcon:require(`@/assets/customKanBan/白色模块/icon1.png`),//当前图标
            copyData:[],//复制
            layerX:0,//粘贴的位置
            layerY:0,//粘贴的位置
            fullScreenStyle:[],//全屏样式
            renovateStyle:[], //刷新样式
        }
    },
    watch:{
       settingFlag(val){
        setTimeout(() => {
             var offsetHeight = document.getElementById("left-demo").offsetHeight
             var offsetWidth = document.getElementById("left-demo").offsetWidth
          
             this.moveBoxList.forEach(item => {
                item.left = ((item.info.left.substring(0,item.info.left.length-1) / 100) * offsetWidth).toFixed(1)
                item.top = ((item.info.top.substring(0,item.info.top.length-1) / 100) * offsetHeight).toFixed(1)
                item.width = ((item.info.width.substring(0,item.info.width.length-1) / 100) * offsetWidth).toFixed(1)
                item.height = ((item.info.height.substring(0,item.info.height.length-1) / 100) * offsetHeight).toFixed(1)

             })
        },600)
       },
       
       moveBoxIndex(val,oval){
       
        if(val == -1){
            var obj = this.moveBoxList[oval].titleStyle
            obj.type = this.moveBoxList[oval].type
            obj.cheekImgType = this.moveBoxList[oval].cheekImgType
            obj.iconImgType = this.moveBoxList[oval].iconImgType
            obj.iconImgIndex = this.moveBoxList[oval].iconImgIndex
            obj.cheekImgIndex = this.moveBoxList[oval].cheekImgIndex
            this.nowModulTitleObj = obj
        }else {
          var obj = this.moveBoxList[val].titleStyle
          obj.type = this.moveBoxList[val].type
          obj.cheekImgType = this.moveBoxList[val].cheekImgType
          obj.iconImgType = this.moveBoxList[val].iconImgType
          obj.iconImgIndex = this.moveBoxList[val].iconImgIndex
          obj.cheekImgIndex = this.moveBoxList[val].cheekImgIndex
          this.nowModulTitleObj = obj
        }
         
       },
       eaitIndex(val,oval){
       
        var index = 0
        if(val == -1){
           let width = this.$refs.dragContent.offsetWidth
           let height = this.$refs.dragContent.offsetHeight
           var info  = this.moveBoxList[this.nowChangeIndex].info
            // var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            // var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
             index = oval
             console.log("index",index);
              
             
             var keyType = this.rightMenuList[index].key
             if(keyType == 'left'){
               info.left = (this.nowInputVal / width).toFixed(4) * 100 + '%'
             }else if(keyType == 'top'){
               info.top = (this.nowInputVal / height).toFixed(4) * 100 + '%'
             }else if(keyType == 'width'){
               info.width = (this.nowInputVal / width).toFixed(4) * 100 + '%'
             }else if(keyType == 'height'){
               info.height = (this.nowInputVal / height).toFixed(4) * 100 + '%'
             }
        }
         
       },
       weathIndex(val){
        
        if(val != -1){
          this.tabIndex = 2
          this.weathObj = this.weatherList[val]
        }else {
           this.weathObj = {}
        }
       },
       timerIndex(val){
          if(val != -1){
          this.tabIndex = 2
          this.trimerObj = this.timerList[val]
          }else {
            this.trimerObj = {}
          }
       }
    },
    mounted(){
      document.onkeydown=(e)=>{
       
	    	if(e.keyCode == 46){//这是delete健，当然也可以根据自己的需求更改
           if(this.moveBoxIndex != -1 && this.eaitIndex == -1){
              this.del_fn(`moveBox${this.moveBoxIndex+1}`)
           }else if(this.weathIndex != -1){
                this.del_fn(`weather${this.weathIndex+1}`)
           }else if(this.timerIndex != -1){
                this.del_fn(`timer${this.timerIndex+1}`)
           }
	     	}
        if (e.keyCode == 67 && e.ctrlKey) {
              if(this.moveBoxIndex != -1 ){
                 this.copyData = []
                 this.copyData.push(this.moveBoxList[this.moveBoxIndex])
              }
        }
        if (e.keyCode == 86 && e.ctrlKey) {

            var newAdd = copy(this.copyData[0])
            if( this.copyData.length == 0){
               this.$message({ message: '请先复制所需粘贴的模块', type: 'warning' });
               return
            }
             let width = this.$refs.dragContent.offsetWidth
           let height = this.$refs.dragContent.offsetHeight
            newAdd.left = this.layerX - (newAdd.width / 2)
            newAdd.info.left = ((this.layerX - (newAdd.width / 2)) / width).toFixed(2)  * 100 + '%'
            newAdd.top = this.layerX - (newAdd.width / 2)
            newAdd.info.top = ((this.layerY - (newAdd.height / 2)) / height).toFixed(2)  * 100 + '%'

            this.moveBoxList.push(newAdd)
            this.moveBoxIndex = this.moveBoxList.length - 1
            
        }

    	}
       
        
        this.offsetHeight = document.getElementById("left-demo").offsetHeight
        this.offsetWidth = document.getElementById("left-demo").offsetWidth
     
        for(let i = 24;i <= 40;i++){
            if(i % 2 == 0){
                this.fontSizeList.push({
                    value:i,
                    label:i
                })
            }
        }

        this.Weather = (JSON.parse(localStorage.getItem('Weather')))
        this.weatherImg = require(`../../../public/static/image/科技蓝/weather/${ this.Weather.weather}.png`)
        var that =  this
        //天气
        this.setIntervalTimer =  setInterval(() => {
           that.Weather = (JSON.parse(localStorage.getItem('Weather')))
           that.weatherImg = require(`../../../public/static/image/科技蓝/weather/${ that.Weather.weather}.png`)
        },1800000)
        //日期
         this.setTimer = setInterval(() => {
           this.timer_fn()
        },1000)
       
          
    },
    destroyed() {
			clearInterval(this.setIntervalTimer)
			clearInterval(this.setTimer)
		},
		beforeDestroy(){
			 clearInterval(this.setIntervalTimer)
			 clearInterval(this.setTimer)
		},
    methods:{
      //时间
      timer_fn(){
        let date = new Date();
        let sign2 = ":";
        let year = date.getFullYear() // 年
        let month = date.getMonth() + 1; // 月
        let day = date.getDate(); // 日 
        let hour = date.getHours(); // 时
        let minutes = date.getMinutes(); // 分
        let seconds = date.getSeconds() //秒
        let weekArr = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        let week = weekArr[date.getDay()]; //getDay() 从 Date 对象返回一周中的某一天 (0 ~ 6)
        // 给一位数的数据前面加 “0”
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        this.nowTime = year + "-" + month + "-" + day
        this.nowWeek = week
        this.nowMin = hour + sign2 + minutes + sign2 + seconds
      },
      //为了解决点击菜单就消失
      addDel_fn(){},

      //输入框失去焦点或者按下回车
      blur_fn(val,index){
        this.nowChangeIndex = index
          this.eaitIndex = -1
          this.nowInputVal = val
      },
      //点击复制
      copy_fn(index){
                 this.copyData = []
                 this.copyData.push(this.moveBoxList[index])
      },
      
      //取消右击菜单跟模块高亮
      leftDemoClick(e){
         this.layerX = e.layerX
         this.layerY = e.layerY
        this.moveBoxIndex = -1
        this.weathIndex = -1
          this.moveBoxList.forEach(item => {
              item.rightMenu = false
          })
      },
      moveBoxClick_fn(index){
        this.moveBoxIndex = index
         this.tabIndex = 1
        this.weathIndex = -1
        this.moveBoxList.forEach(item => {
          item.rightMenu = false
        })
      },
        //下载图片
       generateImages () {
            html2canvas(document.querySelector('.left-demo')).then(canvas => {
            const imgUrl = canvas.toDataURL('image/jpeg')
            const image = document.createElement('img')
            image.src = imgUrl
            // 将生成的图片放到 类名为 content 的元素中
            // document.querySelector('.content').appendChild(image)
            const a = document.createElement('a')
            a.href = imgUrl
            // a.download 后面的内容为自定义图片的名称
            a.download = 'study_download'
            a.click()
            })
        },
       
        //自定义宽度
        moveLineWidth(e,index) {
            this.offsetWidth = document.getElementById("left-demo").offsetWidth
            let that = this
            let moveBoxObj = document.getElementById(index)// 最大的框，自带相对定位属性
            let moveStartX = e.clientX 
            var index = moveBoxObj.id.slice(-1)
            let moveLineObjOffsetLeft = moveBoxObj.offsetWidth // 得到点击时该line的左边距
            let offsetLeft = moveBoxObj.offsetLeft
             document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                e = e || window.event
                 let mouseMoveDistance = e.clientX - moveStartX // 鼠标滑动距离（正则是往右；负则是往左）
                 let styleLeft = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleLeft = styleLeft >= (that.offsetWidth - 20 - offsetLeft) ? (that.offsetWidth - 20 - offsetLeft) : styleLeft
                 styleLeft =  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100  < 23 ? 23 :  ( (styleLeft / that.offsetWidth).toFixed(3) ) * 100
                //  console.log("宽度",((styleLeft / 100) * that.offsetWidth).toFixed(2) );
                 that.moveBoxList[index - 1].info.width = styleLeft.toFixed(2) + '%'
                //  that.moveBoxList[index - 1].width = styleLeft
                 that.moveBoxList[index - 1].width = ((styleLeft / 100) * that.offsetWidth).toFixed(1)
                // moveBoxObj.style.width = styleLeft + '%'
            
                }
            document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                 };
            
        },
        //自定义高度
            moveLineHeight(e,index){
                this.offsetHeight = document.getElementById("left-demo").offsetHeight
                let that = this
                let moveBoxObj = document.getElementById(index) // 最大的框，自带相对定位属性
                   var index = moveBoxObj.id.slice(-1)
                let moveStartY = e.clientY 
                let moveLineObjOffsetLeft = moveBoxObj.offsetHeight // 得到点击时该line的左边距
                 let offsetTop = moveBoxObj.offsetTop
                  document.onmousemove = (e) => {    //鼠标按下并移动的事件
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                e = e || window.event
                 let mouseMoveDistance = e.clientY - moveStartY // 鼠标滑动距离（正则是往右；负则是往左）
                let styleHeight = moveLineObjOffsetLeft + mouseMoveDistance// 左边距 = 线条初始（左边距）位置 + 鼠标滑动的距离
                 styleHeight = styleHeight >= (that.offsetHeight - 45 - offsetTop) ? (that.offsetHeight - 45 - offsetTop) : styleHeight
                 styleHeight =  ( (styleHeight / (that.offsetHeight)).toFixed(3) ) * 100  < 20 ? 20 :  ( (styleHeight / (that.offsetHeight )).toFixed(3) ) * 100
                //  moveBoxObj.style.height = styleHeight + '%'
              that.moveBoxList[index - 1].info.height = styleHeight.toFixed(2) + '%'
                //  that.moveBoxList[index - 1].width = styleLeft
                 that.moveBoxList[index - 1].height = ((styleHeight / 100) * that.offsetHeight).toFixed(1)
                // moveBoxObj.style.width = styleLeft + '%'
            
                }
                document.onmouseup = (e) => {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };


              
        },
        //添加模块
        addMoveBox_fn(){
            let width = this.$refs.dragContent.offsetWidth
           let height = this.$refs.dragContent.offsetHeight
            if(this.moveBoxList.length >= 16){
                this.$message({ showClose: true, message: '最多不能超过16个模块！', type: 'warning'});
                return
            }
           var leftPx = this.coordinate.clientX - 340
           var topPx = this.coordinate.clientY - 140
            var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
            var d = {
                'id':new Date().getTime(),
                 'left':leftPx,
                  'top':topPx,
                  'width':(23 / 100) * width,
                  'height':(20 / 100) * height,
                'info':{
                  'left':left + '%',
                  'top':top + '%',
                  'width':'23%',
                  'height':'20%',
                },
                'titleStyle':{
                  'name':'标题',
                  'fontSize':"16px" ,
                  'color':"#fff",
                },
                'rightMenu':false,
                'type':this.coordinate.type,
                'iconImgType':this.coordinate.iconImgType,
                'iconImgIndex':this.coordinate.iconImgIndex,
                'iconImg':this.coordinate.iconImg,
                'cheekImgType':this.coordinate.cheekImgType,
                 'cheekImgIndex':this.coordinate.cheekImgIndex,
                'cheekImg':this.coordinate.cheekImg,
                'iconFlag':this.coordinate.iconFlag
            }
            if(this.coordinate.type == 1){
              d.info.backgroundImage = `url(${this.coordinate.cheekImg})`

              // d.info.backgroundColor = 'red'
            }
            this.moveBoxList.push(d)
            this.moveBoxIndex = this.moveBoxList.length - 1
             this.weathIndex = -1
             
 
            
        },
        //删除模块
        del_fn(divId){
            var dom=document.getElementById(divId);
	          dom.parentNode.removeChild(dom);
 
       
  

            
        
        },
        // 模块拖拽
      tagDraggable (e,index) {
     
        // 获取目标元素
        e = e || window.event
        let odiv = e.target;
        // var moveBoxAll  = document.querySelectorAll('.moveBox')
        if(odiv.className.includes('top-title')){
          odiv = (e.target).parentNode
        }

        if (!odiv.className.includes('moveBox')) return
        this.tagDraggable_fn(e,odiv,index,this.moveBoxList)
      },
      tagDraggable_fn(e,odiv,index,data){
          // 算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
        let width = this.$refs.dragContent.offsetWidth
        let height = this.$refs.dragContent.offsetHeight
        var newleft = odiv.offsetLeft
        var newtop = odiv.offsetTop
        document.onmousemove = (e) => {    //鼠标按下并移动的事件
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          this.zujianFlag = false
          e = e || window.event
          let left = e.clientX - disX;
          let top = e.clientY - disY;
         
          // 标签不能移动到容器外
          left < 20 && (left =20)
          left > (width - odiv.offsetWidth - 20) && (left =(width - odiv.offsetWidth - 20))
          top < 20 && (top = 20)
          top > (height - odiv.offsetHeight - 40) && (top = height - odiv.offsetHeight - 40)
          newleft = left
          newtop = top

          // 移动当前元素
          odiv.style.left = `${left}px`;
          odiv.style.top = `${top}px`;
        }
        document.onmouseup = (e) => {
          data[index].left = newleft
          data[index].top = newtop
          // newleft =   ( ((Math.round(newleft / 10) * 10) / width).toFixed(4) ) * 100
          // newtop =   ( ((Math.round(newtop / 10) * 10) / height).toFixed(4) ) * 100
            newleft =   ( (newleft / width).toFixed(4) ) * 100
          newtop =   ( (newtop  / height).toFixed(4) ) * 100
          data[index].info.left = newleft.toFixed(2)  + '%'
          data[index].info.top = newtop.toFixed(2)   + '%'

          // odiv.style.left = `${newleft}%`
          // odiv.style.top = `${newtop}%`
          document.onmousemove = null;
          document.onmouseup = null;
        };
      },
      //鼠标右键
      rightClick(e,index){
        // console.log("鼠标右键");
          e = e || window.event
           let odiv = e.target;
            var   arr =  odiv.childNodes
            let appoint = ""
            for(let i = 0;i<arr.length;i++){
                if(arr[i].className == 'add-del'){
                    appoint = arr[i]
                }
            }
            appoint.style.left = `${e.offsetX}px`;
            appoint.style.top = `${e.offsetY}px`;
              this.moveBoxList.forEach(item => {
                item.rightMenu = false
              })
              this.moveBoxIndex = index
             this.moveBoxList[index].rightMenu = true

      },
      //大标题拖放
      titleMove(e){
        e = e || window.event
        let odiv = e.target;     
         let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
        let height = this.$refs.dragContent.offsetHeight
        var newleft = odiv.offsetLeft
        // var newtop = odiv.offsetTop
        document.onmousemove = (e) => {    //鼠标按下并移动的事件
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          e = e || window.event
          let top = e.clientY - disY;
         
          top < 20 && (top = 20)
          top > (height - odiv.offsetHeight - 70) && (top = height - odiv.offsetHeight - 70)
        //   newleft = left
        //   newtop = top

          odiv.style.top = `${top}px`;
        }
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };

      },
      //上传背景图片
       handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true
      },
      //上传主题
      zhutiImg_fn(file){
         this.bgImgList.push({'url':file.url})
      },
      //切换背景
      change_bg(index){
        this.activeIndex = index
        if(this.switchValue){
            if(index < 8){
                this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].urlTran})`}
            }else {
                 this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].url})`}
            }
        }else {
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[index].url})`}
        }
      },
      //启用禁用背景图片
      switch_fn(val){
        //  console.log("背景图片",val);
        if(val){
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[this.activeIndex].urlTran})`}
        }else {
            this.nowBgImg = {backgroundImage: `url(${this.bgImgList[this.activeIndex].url})`}

        }
      },
      //标题字体
      fontSize_fn(){
         this.fontSize = {fontSize:this.sizeValue+'px',color:this.titleColor}
      },
      //字体颜色
      color_fn(val){
           this.titleColor = val
           this.fontSize = {fontSize:this.sizeValue+'px',color:this.titleColor}
      },
      //小模块标题形状
      shape_fn(val){
        this.shapeValue = val
        this.moduleStyle()
      },
      //小模块标题图标
      nowIcon_fn(val){
        if(this.moveBoxIndex == -1){
          this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
          this.moveBoxList[this.moveBoxIndex].iconImgType = val.iconValue
          this.moveBoxList[this.moveBoxIndex].iconImg = val.iconImg
          this.moveBoxList[this.moveBoxIndex].iconImgIndex = val.iconImgIndex
      },
      //图标是否启用
      iconFlag_fn(val){
        if(this.moveBoxIndex == -1){
          this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
        this.moveBoxList[this.moveBoxIndex].iconFlag = val
      },
      //小模块有边框类型
      nowCheek_fn(val){
        if(this.moveBoxIndex == -1){
           this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
          this.moveBoxList[this.moveBoxIndex].cheekImgType = val.cheekImgType
          this.moveBoxList[this.moveBoxIndex].cheekImg = val.cheekImg
          this.moveBoxList[this.moveBoxIndex].info.backgroundImage = `url(${val.cheekImg})`
          this.moveBoxList[this.moveBoxIndex].cheekImgIndex = val.cheekImgIndex
      },
      //小模块标题背景渐变
      moduleTitle_fn(val){
           this.moduleBgColor = val
           this.moduleStyle()
      },
      //小模块标题背景颜色
      moduleTitleColor_fn(val){
        this.moduleTitleColor  =  val
        this.moduleStyle()
      },
      //小模块小标题样式
      modelTitleName_fn(obj){
           if(this.moveBoxIndex == -1){
           this.$message({ message: '请选择模块', type: 'warning' });
          return
        }
        this.moveBoxList[this.moveBoxIndex].title = obj.name
          this.moveBoxList[this.moveBoxIndex].titleStyle = obj
      },
      //小模块样式统一变动
      moduleStyle(){
        this.deltaObj  =  {borderRightColor:this.moduleTitleColor}
            if(this.moduleBgColor){
               this.topTitleObj = {background:`linear-gradient(to right, ${this.moduleTitleColor}, transparent)`}
               this.lineObj = {background:`linear-gradient(to right, ${this.moduleTitleColor}, transparent)`}
            }else  {
                this.topTitleObj = {background:this.moduleTitleColor}
                this.lineObj = {background:this.moduleTitleColor}
            }
            if(this.shapeValue == '直线') {
                  this.topTitleObj  = {background:`transparent`}
            }
      },
      //小模块拖放
      coordinate_fn(obj){
        this.coordinate  =  obj
       
        this.addMoveBox_fn()
      },
      //组件拖放
      assembly_fn(val){
          let width = this.$refs.dragContent.offsetWidth
           let height = this.$refs.dragContent.offsetHeight
           var d = val
            var leftPx = val.clientX - 340
           var topPx = val.clientY - 65
           if(val.type == 2 || val.type ==3){
              leftPx = val.clientX - 212
              topPx = val.clientY - 62
           }
            var left =  ( ((Math.round(leftPx)) / width).toFixed(4) ) * 100
            var top =  ( ((Math.round(topPx)) / height).toFixed(4) ) * 100
            d.info = {
                'left':left.toFixed(2) + '%',
                'top':top.toFixed(2) + '%',
                'color':val.color
            }
          
        if(val.type == 2){
          this.fullScreenStyle = []
          this.fullScreenStyle.push(d)
           this.$refs.assembly.screenChange(0,d)
        }
        if(val.type == 3){
           this.renovateStyle = []
           this.renovateStyle.push(d)
            this.$refs.assembly.screenChange(1,d)
        }
           
         if(val.type == 4){
            this.weatherList.push(d)
            setTimeout(() => {
              var weatherAll  = document.querySelectorAll('.weather')
              var div = weatherAll[weatherAll.length - 1]
              div.style.width = (( (div.offsetWidth / width).toFixed(3) ) * 100) + 2  + '%'
             
            },500)
            this.weathIndex = this.weatherList.length - 1
            this.timerIndex = -1
            
         }
         if(val.type == 5){
            this.timerList.push(d)
            setTimeout(() => {
              var timerAll  = document.querySelectorAll('.timer')
              var div = timerAll[timerAll.length - 1]
              div.style.width = (( (div.offsetWidth / width).toFixed(3) ) * 100) + 2  + '%'
             
            },500)
            this.timerIndex = this.timerList.length - 1
            this.weathIndex = -1
         }

         this.moveBoxIndex = -1
      },
      //组件天气拖放
      zujianTagDraggable(e,index,type){
          e = e || window.event
          let odiv = (e.target).parentNode;
          var arr = []
          if(type == 2) {
            arr = this.fullScreenStyle
          }
          if(type == 3){
            arr = this.renovateStyle
          }
          if(type == 4){
            arr = this.weatherList
          }
          if(type == 5){
            arr = this.timerList
          }
          this.zujianFlag = true
          this.tagDraggable_fn(e,odiv,index,arr)
      },
      //全屏/缩小/刷新
      screens_fn(val){  
        if(val.type == 0){
           this.operationTips(this.fullScreenStyle.length == 0 , '请选择全屏/缩小')
           this.fullScreenStyle[0].info.color = val.color
        }else {
          this.operationTips(this.renovateStyle.length == 0 , '请选择刷新')
           this.renovateStyle[0].info.color = val.color
        }
      },
      //全屏/缩小/刷新
      screenRenovate_fn(val,obj){
       
        if(this.settingFlag && this.zujianFlag){
            var flag = resourcesStore.state.customKanBanScreen
            this.screenFlag = !flag

           resourcesStore.commit('setCustomKanBan',!flag)
          
        }
        this.tabIndex = 2
        this.$refs.assembly.screenChange(val,obj)
      },

      //组件天气样式变化
      weathers_fn(val){
       this.operationTips(this.weathIndex == -1 , '请选择需要更改的组件')
        this.weatherList[this.weathIndex].info.color = val.color
        this.weatherList[this.weathIndex].weatherCheckList = val.weatherCheckList

      },
       //组件时间样式变化
      timers_fn(val){
          this.operationTips(this.timerIndex == -1 , '请选择需要更改的组件')
        this.timerList[this.timerIndex].info.color = val.color
        this.timerList[this.timerIndex].timerCheckList = val.timerCheckList

      },
      //操作提示
      operationTips(term,word){
          if(term ){
          this.$message({ message:word, type: 'warning' });
            return 
          }
      },
      

      
      
      //保存看板
      saveKanBan(){}
        
    },
    

}
</script>
<style lang="scss" scoped>
  @import './customKanBan.scss';
</style>
